import React from 'react';
interface HeroProps {
  onStart: () => void;
}
export function Hero({
  onStart
}: HeroProps) {
  return <header className="w-full bg-violeta text-hueso" data-id="element-95" data-mp="ejmp79k77hur">
      <div className="mx-auto w-full max-w-lectura px-6 pb-20 pt-16 sm:pb-24 sm:pt-20" data-id="element-96" data-mp="ei1xdrp9qd0l">
        <p className="font-sans text-sm font-medium tracking-wide text-dorado" data-id="element-97" data-mp="9ipbpaa4vbzl">
          Sube de Nivel · Coaching de relaciones con PNL
        </p>

        <h1 className="mt-6 font-serif text-4xl leading-[1.15] sm:text-5xl md:text-[3.5rem]" data-id="element-98" data-mp="129qudld1bpnv">
          ¿En qué nivel de consciencia estás atrapado después de tu ruptura?
        </h1>

        <p className="mt-6 max-w-xl font-sans text-lg leading-relaxed text-hueso/80" data-id="element-99" data-mp="sb1efy4p8fa9">
          Descubre en 2 minutos por qué te cuesta soltar y qué necesitas hacer para pasar de página
          de verdad.
        </p>

        <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-100" data-mp="3d2lb3gldnd2t">
          <button type="button" onClick={onStart} className="rounded-sm bg-dorado px-8 py-4 font-sans text-base font-semibold text-noche transition-colors duration-150 ease-out hover:bg-dorado-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-hueso focus-visible:ring-offset-2 focus-visible:ring-offset-violeta" data-id="element-101" data-mp="3825y4q50c7ld">
            Hacer el test gratis
          </button>
          <p className="font-sans text-sm text-hueso/60" data-id="element-102" data-mp="3e7uwfm28wlna">
            12 preguntas · 2 minutos · resultado inmediato
          </p>
        </div>
      </div>
      <div className="h-px w-full bg-dorado/40" aria-hidden="true" data-id="element-103" data-mp="358ho4wpuy345" />
    </header>;
}